<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BASIC
                    SCIENCES &
                    BIO-TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Life Science</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science(Medical)</td>
                            <td class="time">Master of Science(Botany)</td>
                            <td class="time">Bachelor of Science(Microbiology)</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time">Master of Science(Zoology)</td>
                            <td class="time">Bachelor of Science(Zoology)</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time"></td>
                            <td class="time">Bachelor of Science(Botany)</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time"></td>
                            <td class="time">Bachelor of Science(Forensic Science)</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Life Science</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Medical)</b>
                    – The three-year undergraduate B.Sc. Medical program at the ARNI School of Basic Science and
                    Bio-Technology covers a wide range of topics pertaining to human biology and health. Collaborative
                    and group discussions, process recordings, nursing care studies, incidental teaching,
                    problem-solving techniques, and research projects are all part of the BSc Medical curriculum.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>: Foundation in Medical Sciences</p>
                <ul>
                    <li>Human Anatomy & Physiology – I</li>
                    <li> Fundamentals of Biochemistry</li>
                    <li> Cell Biology & Genetics</li>
                    <li> Microbiology – Introduction & Scope</li>
                    <li>Organic & Inorganic Chemistry</li>
                    <li> Communicative English & Professional Ethics</li>
                    <li> Laboratory: Microscopy, Histology, Basic Biochemistry Experiments</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>: Core Biological Sciences</p>
                <ul>
                    <li>Human Anatomy & Physiology – II</li>
                    <li> Molecular Biology & Genetics</li>
                    <li>Basic Pathology & Immunology</li>
                    <li> Biophysics & Instrumentation in Medical Sciences</li>
                    <li> Environmental Science & Human Health</li>
                    <li> Laboratory: Hematology, Microbial Culture, DNA Isolation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3
                </b>: Applied Medical Sciences</p>
                <ul>
                    <li>Pharmacology & Toxicology</li>
                    <li>Microbial Infections & Control Methods</li>
                    <li> Metabolism & Enzymology</li>
                    <li>Bioinformatics & Computational Biology</li>
                    <li>Clinical Biochemistry & Diagnostic Techniques</li>
                    <li>Laboratory: Blood Grouping, Enzyme Assays, Spectrophotometry</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4
                </b>: Advanced Biomedical Studies</p>
                <ul>
                    <li>Epidemiology & Public Health</li>
                    <li>Medical Biotechnology & Genomics</li>
                    <li> Food & Nutritional Biochemistry</li>
                    <li> Medical Virology & Immunopathology</li>
                    <li> Research Methodology & Biostatistics</li>
                    <li> Laboratory: ELISA, PCR Techniques, Pathogen Identification</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5
                </b>: Specialization & Research</p>
                <ul>
                    <li> Neuroscience & Endocrinology</li>
                    <li> Cancer Biology & Therapeutics</li>
                    <li> Pharmacogenomics & Personalized Medicine</li>
                    <li> Medical Imaging Techniques (MRI, CT, Ultrasound)</li>
                    <li> Bioethics & Regulatory Affairs</li>
                    <li> Laboratory: Tumor Marker Analysis, Histopathology, Toxicity Testing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6
                </b>: Emerging Trends & Career Readiness</p>
                <ul>
                    <li>Stem Cell & Regenerative Medicine</li>
                    <li>Advances in Clinical Microbiology</li>
                    <li>Drug Development & Clinical Trials</li>
                    <li>Nanotechnology in Medicine</li>
                    <li> Dissertation & Research Project</li>
                    <li> Laboratory: Advanced Molecular Diagnostics, Tissue Engineering</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Microbiology) </b>
                    – The biology of bacteria, viruses, fungi, and protozoan parasites are just a few of the many
                    subjects covered in the three-year undergraduate Bachelor of Science (Microbiology) curriculum at
                    the ARNI School of Basic Science and Bio-Technology. Microbial physiology, microbial genetics,
                    immunology, genetic engineering, biotechnology, molecular biology, bioinstrumentation, and general
                    microbiology are the main topics of a bachelor's degree in microbiology.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Introduction to Biology</li>
                    <li> Microbial Metabolism</li>
                    <li> Introduction to Microbiology and Microbial Diversity</li>
                    <li> Enzymology</li>
                    <li> Microbial Diversity</li>
                    <li> Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Microbiology</li>
                    <li> Mycology and Phycology</li>
                    <li> DNA Technology</li>
                    <li> Biochemistry</li>
                    <li> Cell Biology</li>
                    <li> Bioinformatics (GE)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Microbial Physiology and Metabolism</li>
                    <li> Infection Immunity and Diagnostics</li>
                    <li> Virology</li>
                    <li> Intellectual Property Rights and Ethical Issues</li>
                    <li> Molecular Biology</li>
                    <li> Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Recombinant DNA Technology</li>
                    <li> Host-Pathogen Interaction</li>
                    <li> Environmental Microbiology and Waste Management</li>
                    <li> Fermentation Technology</li>
                    <li> Inheritance Biology</li>
                    <li> Microbial Genetics</li>
                    <li> Dissertation - I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Industrial Microbiology</li>
                    <li> Food and Dairy Microbiology</li>
                    <li> Research Methodology</li>
                    <li> Medical Bacteriology</li>
                    <li> Environmental and Agricultural Microbiology</li>
                    <li> Enzyme technology</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Microbial Technology – Social, Legal &Ethical Issues</li>
                    <li> Immunology</li>
                    <li> Pharmacology</li>
                    <li> Medical Microbiology</li>
                    <li> Parasitology</li>
                    <li> Elective II</li>
                    <li> Dissertation – II</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Zoology)</b>
                    – The three-year undergraduate Bachelor of Science (Zoology) program at the ARNI School of Basic
                    Science and Bio-Technology offers comprehensive understanding of a range of capabilities, including
                    ecology, genetics, physiology, etc. It offers a vast array of information about animals, including
                    their classifications, evolution, structure, genetics, biochemistry, etc.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Non-Chordates I: Protista to Pseudocoelomates</li>
                    <li> English Communication</li>
                    <li> Principles of Ecology</li>
                    <li> Elements of Cell Biology, Evolution, and Ecology - Theory</li>
                    <li> Elements of Cell Biology, Evolution, and Ecology- Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Non-Chordates II: Coelomates</li>
                    <li> Environmental Science</li>
                    <li> Cell Biology</li>
                    <li> Taxonomy, Evolution, and Elementary Paleontology</li>
                    <li> Elementary Biotechnology, Molecular Biology, and Biological Techniques</li>
                    <li> Genetics – Practical, and Theory</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Ecology and Environmental Biology</li>
                    <li> Higher Chordata</li>
                    <li> Lower Chordata</li>
                    <li> Ecology and Environmental Biology- Practical</li>
                    <li> Lower Chordata- Practical</li>
                    <li> Higher Chordata- Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Applied Ichthyology & Elementary Entomology</li>
                    <li> Developmental Biology</li>
                    <li> Applied Zoology</li>
                    <li> Elementary Entomology and Applied ichthyology- Practical</li>
                    <li> Applied Zoology- Practical</li>
                    <li> Developmental Biology- Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Toxicology and Histology</li>
                    <li> Microbiology</li>
                    <li> Animal Behavior</li>
                    <li> Toxicology and Histology- Practical</li>
                    <li> Animal Behavior- Practical</li>
                    <li> Microbiology- Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Biostatistics Endocrinology & Bioinformatics</li>
                    <li> Basic Mammalian Endocrinology & Biological Chemistry</li>
                    <li> Animal Physiology-Endocrinology</li>
                    <li> Biostatistics Endocrinology & Bioinformatics - Practical</li>
                    <li> Basic Mammalian Endocrinology & Biological Chemistry - Practical</li>
                    <li> Animal Physiology-Endocrinology - Practical</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Botany)</b>
                    – The ARNI School of Basic Science and Bio-Technology's three-year undergraduate Bachelor of Science
                    in Botany program provide a thorough understanding of a variety of topics, including economic
                    botany, genetics, molecular biology, plant ecology and phytogeography, mycology and phytopathology,
                    algae and microbiology, biomolecules and cell biology, archegoniate, morphology and anatomy, and
                    more.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Phycology and microbiology Practical</li>
                    <li> Phytopathology & Mycology</li>
                    <li> Microbiology and Phycology</li>
                    <li> Plant taxonomy And Embryology</li>
                    <li> Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Cell and Molecular Biology</li>
                    <li> Morphogenesis, Reproductive Biology, and Tissue culture</li>
                    <li> Plant Morphology and Anatomy</li>
                    <li> Taxonomy of Angiosperms</li>
                    <li> Research Paper/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Plant Breeding, Cytogenetics, and Biostatistics</li>
                    <li> Biochemical Techniques & Plant Biochemistry</li>
                    <li> Plant Physiology and Biochemistry</li>
                    <li> Plant Biotechnology</li>
                    <li> Dissertation - I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Bioinformatics and IPR</li>
                    <li> Plant Resource, Utilization and Conservation</li>
                    <li> Molecular Techniques and Plant Molecular Biology</li>
                    <li> Elective I</li>
                    <li> Dissertations- II</li>

                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Science (Zoology)</b>
                    – The ARNI School of Basic Science and Bio-Technology's two-year postgraduate Bachelor of Science
                    (Zoology) program provides a thorough understanding of a variety of skills, including animal
                    physiology, evolutionary biology, faunal diversity, and applied subjects like biochemistry,
                    physiology, developmental biology, enzymology, and molecular biology.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Genetic Engineering</li>
                    <li> Parasites and Immunity</li>
                    <li> Tissue Structure Function and Chemistry</li>
                    <li> Ecological theories and Applications</li>
                    <li> Laboratory course</li>
                    <li> Structure and Functions of Non-chordates</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Cell and Receptor Biology</li>
                    <li> Endocrinology and Neuroscience</li>
                    <li> Biochemistry and Molecular biology</li>
                    <li> Comparative Animal Physiology</li>
                    <li> Structure and Functions of Chordates</li>
                    <li> Research Paper/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Taxonomy and Biodiversity</li>
                    <li> Evolution and Animal Behavior</li>
                    <li> Development and Differentiation</li>
                    <li> Elective I</li>
                    <li> Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Biostatistics, Bioinformatics, and Instrumentation</li>
                    <li> Biotechnology and Applications</li>
                    <li> Conservation Biology and Wildlife</li>
                    <li> Elective II</li>
                    <li> Dissertation</li>
                </ul>
            </div>


            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">B.Sc. in Medical Radiology and Imaging Technology</b>
                    – The ARNI School of Allied Health Sciences offers a three-year undergraduate degree called a
                    Bachelor of Science in Radiology and Imaging Technology. The principles and applications of imaging
                    technologies used in medical diagnosis and therapy are the main focus. Comprehensive instruction in
                    imaging modalities like X-ray, MRI, CT scan, ultrasound, and nuclear medicine is part of the BSc in
                    Radiology and Imaging Technology program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Commutative English I</li>
                    <li> Human Anatomy as Applied to Radiology & Imaging I</li>
                    <li> Human Physiology I</li>
                    <li> Pathology I</li>
                    <li> Radiological Physics I</li>
                </ul>
            </div>


        </div>

    </div>
</section>
